module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_foilGoldHover-c0a4d6dd531ec90a56f99064be2c8192.jpg";